import { DesktopMenu } from "./DesktopMenu";
import { MobileMenu } from "./MobileMenu";
import { Link } from "react-router-dom";
import { supabase } from "@/integrations/supabase/client";

interface HeaderProps {
  userName: string;
  onSignOut: () => Promise<void>;
}

export const Header = ({ userName, onSignOut }: HeaderProps) => {
  const handleSignOut = async () => {
    // Set the explicit logout flag before signing out
    localStorage.setItem('explicitly_logged_out', 'true');
    await onSignOut();
  };

  return (
    <header className="fixed top-0 left-0 right-0 bg-background/95 backdrop-blur supports-[backdrop-filter]:bg-background/60 z-50 border-b border-border/40">
      <div className="container flex justify-between items-center h-16 px-4 animate-fade-in">
        <div className="flex items-center gap-8">
          <div>
            <img 
              src="/lovable-uploads/d8edf8a7-daeb-4805-8270-304464f41613.png" 
              alt="MindTube" 
              className="h-8 md:h-10 w-auto transition-all duration-300"
            />
            {userName && (
              <p className="text-sm text-muted-foreground mt-1 transition-opacity">
                Welcome, {userName}
              </p>
            )}
          </div>
        </div>

        <DesktopMenu onSignOut={handleSignOut} />
        <MobileMenu onSignOut={handleSignOut} />
      </div>
    </header>
  );
};